import router from "@/router/router";
import httpService from "@/services/http.service";
import storageService from "@/services/storage.service";
import utilService from "@/services/util.service";
import { useMessenger } from "@/views/private/social/messenger/messenger.composable";
import {
  FacebookAuthProvider,
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  TwitterAuthProvider,
} from "firebase/auth";
import { ref } from "vue";
import { TYPE } from "vue-toastification";
declare global {
  interface Window {
    dataLayer: any[];
  }
}
export const SocialLoginComposables = () => {
  const userData = ref<any>({});
  const signUpRef = ref<any | null>(null);
  // const { listenToConversations, clearComposable } = useMessenger();

  const twitterLogin = () => {
    // const auth = getAuth();
    // const provider = new TwitterAuthProvider();
    // signInWithPopup(auth, provider)
    //   .then((result:any) => {
    //     const credential = TwitterAuthProvider.credentialFromResult(result);
    //     userData.value = {
    //       token: result.user?.accessToken!,
    //       user: {
    //         email: result.user?.email,
    //         uid: result.user?.uid,
    //       },
    //     };
    //     if (userData.value) {
    //       socialSignup(userData.value);
    //     }
    //   })
    //   .catch((error) => {
    //     const errorMessage = error.message;
    //     utilService.showToast(errorMessage, TYPE.ERROR);
    //   });
    utilService.showToast("Development In Progress", TYPE.SUCCESS);
  };

  const facebookLogin = () => {
    // const auth = getAuth();
    // const provider = new FacebookAuthProvider();
    // signInWithPopup(auth, provider)
    //   .then(async (result) => {
    //     const credential = FacebookAuthProvider.credentialFromResult(result);
    //   })
    //   .catch((error: any) => {
    //     const errorMessage = error.message;
    //     utilService.showToast(errorMessage, TYPE.ERROR);
    //   });
    utilService.showToast("Development In Progress", TYPE.SUCCESS);
  };

  const googleLogin = () => {
    const auth = getAuth();
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider)
      .then(async (result: any) => {
        const credential = GoogleAuthProvider.credentialFromResult(result);
        userData.value = {
          token: result.user?.accessToken!,
          user: {
            email: result.user?.email,
            uid: result.user?.uid,
            fullName: result.user?.displayName,
            ref: signUpRef.value ? signUpRef.value : "-",
          },
        };
        if (userData.value) {
          socialSignup(userData.value);
        }
      })
      .catch((error: any) => {
        // const errorMessage = error.message;
        // utilService.showToast(errorMessage, TYPE.ERROR);
      });
  };

  const socialSignup = async (data: any) => {
    try {
      await httpService
        .socialSignup(data)
        .then((response: any) => {
          if (response.data.isSuccess) {
            // listenToConversations();
            storageService.setUser(response.data.data.user);
            storageService.setIsFirebaseLogin(true);
            storageService.setToken(response.data.data.token.accessToken);
            storageService.setBackground(response.data.data.user);
            window.dataLayer = window.dataLayer || [];
            if (!response.data.data.user.isProfileCompleted) {
              window.dataLayer.push({
                event: "subscribe_success",
                method: "socialSignUp",
              });
              router.push({ path: "/profile/create" });
            } else {
              router.push({
                name: "feed",
              });
            }
            utilService.showToast("Login Succesfully.");
          } else {
            if (response.data.message === "You are in waitlist.") {
              router.push({ name: "approveAccess" });
            } else {
              utilService.showToast(response.data.message, TYPE.ERROR);
            }
          }
        })
        .catch((e: any) => { });
    } catch (e) { }
  };

  return {
    signUpRef,
    googleLogin,
    facebookLogin,
    twitterLogin,
  };
};
